import { useEffect } from "react";

/**
 * Shows the Shopify admin loading bar while mounted.
 * Replacement for the `<Loading />` component from App Bridge v3.
 */
const Loading = () => {
  useEffect(() => {
    shopify.loading(true);
    return () => shopify.loading(false);
  }, []);

  return null;
};

export default Loading;
